<template>
	<p class="font-[Inter] text-sm font-normal text-won-blue">
		<span v-html="highlightedMessage" />
		<span
			v-if="showTime"
			class="whitespace-nowrap text-won-dark-gray"
		>&nbsp;{{ periodLabelText() }} </span>
	</p>
</template>
<script setup>
import { ref } from 'vue';
import { escapeRegExp, getPeriodTextLabel } from '../../../utils/helpers';

const props = defineProps({
	message: {
		type: String,
		default: '',
	},
	actionText: {
		type: String,
		default: '',
	},
	actionLink: {
		type: String,
		default: '',
	},
	createdAt: {
		type: Date,
		default: Date.now()
	},
	showTime: {
		type: Boolean,
		default: true,
	},
});

const { message, actionText, actionLink, createdAt } = props;

const anchorTag = `<a href="${actionLink}" class="text-sm font-bold text-won-green underline">${actionText}</a>`;
const escapedText = escapeRegExp(actionText);
const regex = new RegExp(escapedText);

const highlightedMessage = ref('');

if (regex.test(message)) {
	highlightedMessage.value = message.replace(regex, anchorTag);
} else {
	highlightedMessage.value = `${message} ${anchorTag}`;
}

const periodLabelText = () => {
	const period = getPeriodTextLabel(createdAt.value);

	return period ? `(${period})` : '';
};
</script>
